// extracted by mini-css-extract-plugin
module.exports = {"navlink":"_navlink_navlink__Xp7Mr","active":"_navlink_active__DWyrg"};